import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × LEICA: Precision optics
// Lens grids, rangefinder geometry, depth layering
export function VasarelyLeicaMode({ brand }: ModeRendererProps) {
  const leicaRed = "#DC143C";

  return (
    <g>
      {/* Optical background */}
      <rect x="0" y="0" width="794" height="1123" fill="#0A0A0A" />

      <g transform="translate(397 540)">
        {/* Lens grid (circular optics) */}
        {[0, 1, 2, 3].map((ring) => {
          const baseR = 50 + ring * 60;
          return Array.from({ length: 12 + ring * 4 }).map((_, i) => {
            const angle = (i * Math.PI * 2) / (12 + ring * 4);
            const r = baseR + Math.sin(i) * 8;
            
            return (
              <circle
                key={`${ring}-${i}`}
                cx={Math.cos(angle) * r}
                cy={Math.sin(angle) * r}
                r="12"
                fill="none"
                stroke={leicaRed}
                strokeWidth="1.5"
                opacity="0.3"
              />
            );
          });
        })}

        {/* Rangefinder geometry (focusing frame) */}
        <rect x="-120" y="-90" width="240" height="180" fill="none" stroke={leicaRed} strokeWidth="3" opacity="0.7" />
        <rect x="-110" y="-80" width="220" height="160" fill="none" stroke={leicaRed} strokeWidth="1" opacity="0.5" />
        
        {/* Split-image focus patch */}
        <line x1="-120" y1="0" x2="120" y2="0" stroke={leicaRed} strokeWidth="2" opacity="0.6" />
        <line x1="0" y1="-90" x2="0" y2="90" stroke={leicaRed} strokeWidth="2" opacity="0.6" />

        {/* Depth layering (aperture blades) */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          return (
            <line
              key={angle}
              x1={Math.cos(rad) * 60}
              y1={Math.sin(rad) * 60}
              x2={Math.cos(rad) * 180}
              y2={Math.sin(rad) * 180}
              stroke={leicaRed}
              strokeWidth="3"
              opacity="0.5"
            />
          );
        })}

        {/* Focus circles */}
        {Array.from({ length: 16 }).map((_, i) => {
          const r = 30 + i * 14;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={leicaRed}
              strokeWidth="1"
              opacity={0.35 - i * 0.018}
            />
          );
        })}

        {/* Precision nodes (distance markers) */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          const distances = ["0.7m", "1m", "1.5m", "3m", "∞", "∞"];
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="16"
                fill={leicaRed}
                opacity="0.5"
              />
              <text
                x={Math.cos(rad) * r}
                y={Math.sin(rad) * r + 5}
                textAnchor="middle"
                fontFamily="monospace"
                fontSize="9"
                fill={brand.white}
                opacity="0.8"
              >
                {distances[i]}
              </text>
            </g>
          );
        })}

        {/* Optical grid */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = (i - 6.5) * 44;
            const y = (j - 8.5) * 42;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 18}
                y={y - 18}
                width="36"
                height="36"
                fill="none"
                stroke="#666"
                strokeWidth="0.5"
                opacity="0.15"
              />
            );
          })
        )}

        {/* Central lens */}
        <circle cx="0" cy="0" r="60" fill="#1A1A1A" opacity="0.9" />
        <circle cx="0" cy="0" r="60" fill="none" stroke={leicaRed} strokeWidth="4" opacity="0.8" />
        <circle cx="0" cy="0" r="50" fill="none" stroke={leicaRed} strokeWidth="2" opacity="0.6" />
        
        {/* Red dot */}
        <circle cx="0" cy="-70" r="8" fill={leicaRed} opacity="0.9" />
      </g>

      {/* Leica text */}
      <text x="397" y="1025" textAnchor="middle" fontFamily="serif" fontSize="11" fill={leicaRed} opacity="0.8" fontStyle="italic">
        optique de précision
      </text>
    </g>
  );
}
